import localforage from 'localforage'
import {CITY_KEY} from "../consts/localKeys";
import nameCityToCode from './nameCityToCode'
import verifyCityCode from './verifyCityCode'

function sendCityError() {
  throw new Error("City not exists")
}

async function getCityCode() {

  try {

    let city = await localforage.getItem(CITY_KEY);

    const cityExists = await verifyCityCode(city);

    if(!cityExists) sendCityError();

    return city;

  }catch (e) { throw e }

}

async function setCityCode(cityName) {
  try {

    let cityCode = nameCityToCode(cityName);

    const cityExists = await verifyCityCode(cityCode);

    if(!cityExists) sendCityError();

    await localforage.setItem(CITY_KEY, cityCode);

    return true;

  }catch (e) { throw e; }
}

export { getCityCode, setCityCode }
